
export class LogAlertaPrescRelatorioFiltrosDTO {
  dataIni: string;
  dataFim: string;
  idsClientes: number[];
  idsUnidades: number[];
  idsMedicos: number[];
  idsProdutos: number[];
  cdsRestricoes: string[];

}